import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilRepresentante, usuarioPerfilAtendente, usuarioPerfilFinanceiro } from '../usuario/usuario-perfil';


/** Acessos permitidos a consulta de títulos a receber */
export const acessosTituloReceber: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilRepresentante, usuarioPerfilAtendente, usuarioPerfilFinanceiro];

@Injectable()
export class CanActivateTituloReceber implements CanActivateChild {

    constructor(private authGuard: AuthGuard) { }

    canActivateChild(): boolean {
        return this.authGuard.canActivateAcesso(acessosTituloReceber);
    }
}
